import React, { useReducer } from 'react'
import CouponContext from './couponContext'
import CouponReducer from './couponReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    CLEAR_RESPONSE,
    RESPONSE_STATUS,
    GET_ALL_COUPONS,
    GET_SINGLE_COUPON,
    GET_ALL_USED_COUPONS,
} from './couponTypes'

const CouponState = (props) => {
    const initialState = {
        responseStatus: null,
        search_allcoupons: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_allused_coupons: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_single_coupon: {
            record: {},
        },
    }

    const [state, dispatch] = useReducer(CouponReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllCoupons = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllCoupons', formData, '', 'couponcode'),
            ])
            const from = 'getAllCoupons'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_COUPONS,
                    payload: {
                        records: res.data.data.responseData.record.length
                            ? res.data.data.responseData.record
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('getAllCoupons')
        }
    }

    const getSingleCoupon = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getSingleCoupon', formData, '', 'couponcode'),
            ])
            const from = 'getSingleCoupon'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_COUPON,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const couponAction = async (formData, from = 'couponAction') => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'couponAction', formData, '', 'couponcode'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllUsedCoupons = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllUsedCoupons',
                    formData,
                    '',
                    'couponcode'
                ),
            ])
            const from = 'getAllUsedCoupons'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USED_COUPONS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('getAllCoupons')
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <CouponContext.Provider
            value={{
                responseStatus: state.responseStatus,
                search_allcoupons: state.search_allcoupons,
                search_single_coupon: state.search_single_coupon,
                search_allused_coupons: state.search_allused_coupons,
                getSingleCoupon,
                getAllUsedCoupons,
                getAllCoupons,
                couponAction,
                clearResponse,
            }}
        >
            {props.children}
        </CouponContext.Provider>
    )
}

export default CouponState
